import React from 'react';
import ToggleSwitch from '../ui/ToggleSwitch';

// Shown above the plan cards in PlansModal, RenewalRequired and Register: the auto-renew switch
// (on by default) plus the referral-discount banner. The discount is the same rate whichever
// way the customer pays, so the banner sits outside the switch.
const AutoRenewOption = ({ autoRenew, onChange, discountPercent, cycleLabel }) => (
  <div style={s.wrap}>
    {discountPercent > 0 && (
      <div style={s.discount}>
        🎉 Referral offer: <strong>{discountPercent}% off</strong> your first purchase — applied automatically at checkout.
      </div>
    )}
    <div style={s.row}>
      <ToggleSwitch checked={autoRenew} onChange={onChange} label="Auto-renew" />
      <span>
        <strong>Auto-renew</strong> — charge me automatically every {cycleLabel.toLowerCase()} cycle
        <span style={s.note}>
          {autoRenew
            ? ' You can turn this off anytime in Settings → Billing. For renewals above ₹15,000 your bank may ask you to approve each charge.'
            : ' Off = pay once for a single cycle only. We’ll remind you before it expires. A bigger plan starts as soon as you pay; the same or a lower plan starts when your current plan ends. Days left on a plan are never added.'}
        </span>
      </span>
    </div>
  </div>
);

const s = {
  wrap: { maxWidth: 640, margin: '0 auto 22px', textAlign: 'left' },
  discount: { background: 'var(--success-soft)', color: 'var(--success)', borderRadius: 10, padding: '9px 14px', fontSize: 13, marginBottom: 10, textAlign: 'center' },
  row: { display: 'flex', gap: 10, alignItems: 'flex-start', background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 10, padding: '10px 14px', fontSize: 13, color: 'var(--text)' },
  note: { display: 'block', color: 'var(--text-muted)', fontSize: 12, marginTop: 3, lineHeight: 1.45 },
};

export default AutoRenewOption;
